<template>
  <div
    v-if="operations.length"
    class="alert alert-warning d-flex align-items-center mb-3 mt-2"
    role="alert"
  >
    <i class="fas fa-exclamation-triangle fa-2x me-3"></i>
    <div class="flex-grow-1">
      <h5 class="alert-heading mb-1">
        <strong>{{ $t(isCollect ? "collectContactNotClientTitle" : "contactOutsideOperationTitle") }}</strong>
      </h5>
      <p class="mb-0">
        {{
          $t(isCollect ? "collectContactNotClientBanner" : "contactOutsideOperationBanner", {
            contact: contactName,
            operations: operations.join(", "),
          })
        }}
      </p>
    </div>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";

/** Ruta del endpoint por modelo: solo pagos y cobros tienen este chequeo. */
const ENDPOINTS = {
  payment: "payments",
  collect: "collects",
};

/**
 * Cartel de la vista de un pago o cobro aplicado a una operación en la que su contacto no
 * participa. Al guardar se avisa y se deja seguir; esto es para el que lo mira después
 * (y para los que ya estaban así antes del aviso).
 */
export default {
  name: "ContactOutsideOperationBanner",
  props: {
    modelName: { type: String, required: true },
    itemId: { type: String, default: "" },
    /** Cambia con cada guardado: vuelve a consultar. */
    reloadKey: { type: [String, Number], default: "" },
  },
  data() {
    return { contactName: "", operations: [] };
  },
  computed: {
    /** En un cobro la regla es que el contacto sea el cliente, no solo que participe. */
    isCollect() {
      return String(this.modelName || "").toLowerCase() === "collect";
    },
    endpoint() {
      return ENDPOINTS[String(this.modelName || "").toLowerCase()] || "";
    },
  },
  watch: {
    itemId: "load",
    reloadKey: "load",
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      if (!this.endpoint || !this.itemId) {
        this.operations = [];
        return;
      }
      try {
        const { data } = await wencesApi.get(
          `/api/financial/${this.endpoint}/${encodeURIComponent(this.itemId)}/contact-outside-operation`
        );
        this.contactName = (data && data.contactName) || "";
        this.operations = Array.isArray(data && data.operations) ? data.operations : [];
      } catch (error) {
        // Es un aviso: si la consulta falla, la vista sigue igual.
        console.error("ContactOutsideOperationBanner:", error);
        this.operations = [];
      }
    },
  },
};
</script>
